// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ScriptAttributes = Record<string, any>;

const defaultAttrs: ScriptAttributes = {
  async: true,
};

export const injectScript = (
  src: string,
  attrs: ScriptAttributes = {},
): [HTMLScriptElement, () => HTMLScriptElement] => {
  const script = document.createElement('script');
  Object.keys(attrs).forEach((attr) => {
    // @ts-expect-error not worth typing this
    script[attr] = attrs[attr] || defaultAttrs[attrs];
  });
  script.src = src;
  return [
    script,
    () => {
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript && firstScript.parentNode
        ? firstScript?.parentNode.insertBefore(script, firstScript)
        : document.head.append(script);
      return script;
    },
  ];
};
